// extracted by mini-css-extract-plugin
export default {"hidden":"downloadPaymentReceiptPDFModal_hidden__tFWUc"};